// import components from './components';
import * as components from './components';

document.addEventListener('DOMContentLoaded', () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // loop each registered component
  const componentNames = Object.keys(components);

  componentNames.forEach(componentName => {
    // get nodes by defined selector
    const component = components[componentName];
    const nodesToInstantiate = [...document.querySelectorAll(component.selectorString())];

    // instantiate the js class for each node
    nodesToInstantiate.forEach(node => {
      const props = node.getAttribute('data-props');

      new component(node, JSON.parse(props));
    });
  });
});
